import { Switch } from "antd";
import React from "react";

// LF360-1914: `ariaLabel` is accepted explicitly rather than by spreading the
// rest of the props onto antd's Switch — a caller's stray prop would otherwise
// reach the DOM. Two switches on one settings screen need telling apart, by a
// screen reader as much as by a test.
export const FormSwitch = ({
  checked,
  onChange,
  readOnly,
  ariaLabel,
  className = "",
  style = {},
}) => {
  return (
    <div className={`lf-form-switch ${className}`} style={style}>
      <Switch
        onChange={onChange}
        checked={checked}
        disabled={readOnly}
        aria-label={ariaLabel}
      />
    </div>
  );
};
